<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';
import { ArtistSearchResult } from 'webshop-api';
import { IconName, TranslationKey, TranslationService } from 'webshop-modules';
import IconComponent from '../atoms/Icon.vue';
import { StringUtilities } from "webshop-modules/string/String.utilities";

@Component({
    name: "ArtistComponent",
    components: {
        IconComponent,
    },
})
export default class ArtistComponent extends Vue {
    @Prop()
    public readonly item!: ArtistSearchResult;

    public readonly IconName: typeof IconName = IconName;

    public readonly Translation: typeof TranslationKey = TranslationKey;

    public lang: string = TranslationService.getCountryCode() === 'en' ? 'en' : 'lc';

    public staticUrl: string | null = document.querySelector('body')?.getAttribute('data-static') ?? null;

    public stripTags(title: string): string {
        return StringUtilities.stripTags(title);
    }
}
</script>

<template>
    <a v-if="item.title" class="m-searchListItem" :href="item.url" data-qa="search-list-item">
        <div class="m-searchListItem__block">
            <div class="a-badgeThumb">
                <picture v-if="item.image" class="a-picture -with-ratio" style="padding-bottom: 100%">
                    <img :src="staticUrl + item.image"
                         alt="" role="presentation" />
                </picture>
                <picture v-else class="a-picture -with-ratio" style="padding-bottom: 100%">
                    <img
                        src="//content.eventim.com/sc_f50ef/static/themes/responsive/integration/oeticket/images/elements/artistBlank.jpg"
                        alt="" role="presentation" />
                </picture>
                <div class="leaf ta" v-if="item.isTicketAlarmEnabled"></div>
            </div>
        </div>
        <div class="m-searchListItem__block">
            <h3 class="m-searchListItem__title -artist">{{ stripTags(item.title) }}</h3>
        </div>
        <div class="m-searchListItem__block"></div>
        <div class="m-searchListItem__block">
            <button class="a-btnCta" type="button" v-translate="{ key: Translation.Show_more }">Show more</button>
            <IconComponent class="m-searchListItem__iconCta" :iconId="IconName.Chevron" />
        </div>
    </a>
</template>

<style scoped></style>
